import { experience } from '@logto/schemas';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import useSocialCallbackHandler from '@/pages/Callback/use-social-callback-handler';
import { socialCallbackConnectorIdParameter } from '@/utils/social-connectors';

/**
 * UI-free first hop for web social and SSO callbacks.
 *
 * The provider returns here before the connector-specific verification page is
 * selected. Keeping this route outside the sign-in page prevents a callback
 * from rendering the sign-in form during the hand-off.
 */
const AuthCallback = () => {
  const [searchParameters] = useSearchParams();
  const { socialCallbackHandler } = useSocialCallbackHandler();
  const connectorId = searchParameters.get(socialCallbackConnectorIdParameter);

  useEffect(() => {
    if (connectorId) {
      socialCallbackHandler(connectorId);

      return;
    }

    // A callback without a connector cannot be verified or routed safely.
    window.location.replace(`/${experience.routes.signIn}`);
  }, [connectorId, socialCallbackHandler]);

  return null;
};

export default AuthCallback;
